import { useServiceError } from '@/hooks';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import { notification } from 'antd';
import {
  createDeduction,
  deductions,
  deleteDeduction,
  editDeduction,
  updateDeduction,
} from './Deduction.service';

export function useDeductions(id: number) {
  const query = useQuery(['List-Deductions'], () => deductions(id));

  useServiceError(query.error);

  return query;
}

export function useDeduction() {
  const mutation = useMutation(editDeduction);

  useServiceError(mutation.error);

  return mutation;
}

export function useCreateDeduction() {
  const queryClient = useQueryClient();

  const mutation = useMutation(createDeduction, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Dedução da nota fiscal de serviço criada com êxito!',
      });

      queryClient.invalidateQueries(['List-Deductions']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateDeduction() {
  const queryClient = useQueryClient();

  const mutation = useMutation(updateDeduction, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Dedução da nota fiscal de serviço editada com êxito!',
      });

      queryClient.invalidateQueries(['List-Deductions']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteDeduction() {
  const queryClient = useQueryClient();

  const mutation = useMutation(deleteDeduction, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Parcela excluida com sucesso',
      });

      queryClient.invalidateQueries(['List-Deductions']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
